
import BasePeripheral from '@appblocks/codegeneration/Peripherals/_BasePeripheral';
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import {
    CodeBlock, BlockType, SettingType, Setting, SettingState, TibboDataType, FeatureType,
} from '@appblocks/codegeneration/types';

export default class BaseSPIPeripheral extends BasePeripheral {
    constructor() {
        super();
        const settings = [
            {
                id: 'SPI',
                name: 'SPI Bus',
                settingType: SettingType.OPTION,
                refId: 'spi',
                required: true,
                group: 'GENERAL',
                default: '',
            },
            {
                id: 'ADDRESS',
                name: 'SPI Address (starting from 0)',
                settingType: SettingType.NUMBER,
                required: true,
                group: 'GENERAL',
                default: '0',
            },
            {
                id: 'CS',
                name: 'Chip Select Pin',
                settingType: SettingType.OPTION,
                required: true,
                refId: 'gpio',
                group: 'GENERAL',
                default: '',
            },
        ];

        this.settings = this.settings.concat(settings);
    }
}
